export default __webpack_public_path__ + "static/media/61.0a5334f2.png";